var _rect, _rect2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 117,
    viewBox: "0 0 115 117",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 115,
    height: 117,
    fill: "#E5E5E5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -7666,
    y: -1005,
    width: 15000,
    height: 2007,
    fill: "#D9D9D9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10559_7818)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1080,
    transform: "translate(-871 -417)",
    fill: "#F2F3F8"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_10559_7818)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -423,
    y: -267,
    width: 962,
    height: 507,
    rx: 5,
    fill: "white"
  })), /*#__PURE__*/React.createElement("ellipse", {
    cx: 57.5,
    cy: 58.5,
    rx: 57.5,
    ry: 58.5,
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.499 39.7564C56.0822 39.7565 54.6797 40.0356 53.374 40.5773C52.0682 41.1191 50.8856 41.9126 49.8955 42.9111C48.9054 43.9096 48.1279 45.0931 47.6087 46.392C47.0894 47.6908 46.8389 49.0788 46.8719 50.4744C46.8762 50.6581 46.8432 50.8408 46.7749 51.0117C46.7065 51.1826 46.6042 51.3383 46.4738 51.4697C46.3435 51.6011 46.1879 51.7055 46.016 51.7767C45.8441 51.848 45.6596 51.8847 45.4731 51.8846H43.5115C41.7308 51.8846 40.0231 52.5816 38.764 53.8222C37.5049 55.0628 36.7975 56.7455 36.7975 58.5C36.7975 60.2545 37.5049 61.9372 38.764 63.1778C40.0231 64.4184 41.7308 65.1154 43.5115 65.1154H54.4106C54.2349 66.0074 54.142 66.9291 54.142 67.8718H43.5115C40.9889 67.8718 38.5696 66.8844 36.7859 65.1269C35.0021 63.3693 34 60.9856 34 58.5C34 56.0144 35.0021 53.6307 36.7859 51.8731C38.5696 50.1156 40.9889 49.1282 43.5115 49.1282H44.1169C44.6865 42.3364 50.4605 37 57.499 37C64.5375 37 70.3116 42.3364 70.8811 49.1282H71.4865C72.8676 49.1279 74.2321 49.424 75.4853 49.9958C76.7385 50.5675 77.8502 51.4014 78.7434 52.4393C79.6365 53.4772 80.2895 54.6943 80.657 56.0059C81.0245 57.3176 81.0978 58.6924 80.8716 60.0348C80.0777 58.8377 79.1065 57.7644 77.9902 56.8506C77.6188 55.4293 76.7782 54.17 75.6008 53.271C74.4235 52.372 72.9761 51.8842 71.4865 51.8846H69.5249C69.3385 51.8847 69.1539 51.848 68.982 51.7767C68.8102 51.7055 68.6545 51.6011 68.5242 51.4697C68.3939 51.3383 68.2915 51.1826 68.2232 51.0117C68.1548 50.8408 68.1218 50.6581 68.1262 50.4744C68.1284 50.3936 68.1295 50.3124 68.1295 50.2308C68.1295 47.4528 67.0095 44.7886 65.0159 42.8243C63.0223 40.86 60.3184 39.7564 57.499 39.7564ZM80.998 67.8718C80.998 74.5699 75.487 80 68.689 80C61.8911 80 56.38 74.5699 56.38 67.8718C56.38 61.1737 61.8911 55.7436 68.689 55.7436C75.487 55.7436 80.998 61.1737 80.998 67.8718ZM69.808 61.2564C69.808 60.964 69.6901 60.6835 69.4803 60.4768C69.2704 60.27 68.9858 60.1538 68.689 60.1538C68.3923 60.1538 68.1076 60.27 67.8978 60.4768C67.6879 60.6835 67.57 60.964 67.57 61.2564V70.0769C67.57 70.3693 67.6879 70.6498 67.8978 70.8566C68.1076 71.0633 68.3923 71.1795 68.689 71.1795C68.9858 71.1795 69.2704 71.0633 69.4803 70.8566C69.6901 70.6498 69.808 70.3693 69.808 70.0769V61.2564ZM68.689 75.8654C69.06 75.8654 69.4158 75.7202 69.6781 75.4617C69.9404 75.2033 70.0878 74.8527 70.0878 74.4872C70.0878 74.1217 69.9404 73.7711 69.6781 73.5126C69.4158 73.2542 69.06 73.109 68.689 73.109C68.3181 73.109 67.9623 73.2542 67.7 73.5126C67.4376 73.7711 67.2903 74.1217 67.2903 74.4872C67.2903 74.8527 67.4376 75.2033 67.7 75.4617C67.9623 75.7202 68.3181 75.8654 68.689 75.8654Z",
    fill: "#BDBDBD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_10559_7818",
    x: -453,
    y: -297,
    width: 1022,
    height: 567,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.321569 0 0 0 0 0.247059 0 0 0 0 0.411765 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10559_7818"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10559_7818",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10559_7818"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1080,
    fill: "white",
    transform: "translate(-871 -417)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyImage);
export default __webpack_public_path__ + "static/media/emptyImage.c1ff8800999045ac6e8935f8457d1a3f.svg";
export { ForwardRef as ReactComponent };